<mat-toolbar>
  <mat-toolbar-row class="d-flex justify-content-between align-items-center">
    <button mat-icon-button (click)="toggleSidenav()">
      <mat-icon>menu</mat-icon>
    </button>

    <div class="header__right-container">
      <div class="header__enterprise-select" *ngIf="usuario">
        <button
          mat-button
          [matMenuTriggerFor]="menuEmp"
          #menuEmpTrigger="matMenuTrigger"
          class="header__enterprise-select-button"
          (click)="loadUsuario()"
        >
          <span *ngIf="empresaSelecionada$ | async as empresa">
            {{ empresa.apelido }}
          </span>
          <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu #menuEmp="matMenu">
          <div
            class="header__enterprise-select-menu-item"
            (click)="$event.stopPropagation()"
            mat-menu-item
            [disableRipple]="true"
          >
            <mat-form-field class="mr-2 form-field-without-padding">
              <mat-label>Selecione a empresa</mat-label>
              <input
                type="text"
                aria-label="Number"
                matInput
                [matAutocomplete]="auto"
                [formControl]="empresaControl"
              />
              <mat-autocomplete
                autoActiveFirstOption
                #auto="matAutocomplete"
                [displayWith]="displayWithFn"
              >
                <mat-option
                  *ngFor="let empresa of empresasFiltradas"
                  [value]="empresa.guid"
                  (onSelectionChange)="
                    menuEmpTrigger.closeMenu(); onChangeEmpresa($event)
                  "
                >
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div class="matriz-filial-badge">
                      <span
                        class="badge {{
                          empresa.tipoEmpresa | badgeTipoEmpresa
                        }} me-2 "
                      >
                        {{ empresa.tipoEmpresa | tipoEmpresa }}
                      </span>
                    </div>
                    {{ empresa.apelido }}
                  </div>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </mat-menu>
      </div>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
